<template>
  <div class="all-page">
    <div class="header">
      <a href="javascript:void(0)" @click="manager('/')" style="float: left;">
        <img src="@/assets/logo.gif" alt="联考之家" class="menu-img-size" />
      </a>
      <div class="header-manager">
        账号管理
      </div>
      <div class="header-home">
        <a href="javascript:void(0)" class="header-home-a" @click="killUser">注销用户</a>
      </div>
      <div class="header-home">
        <a href="javascript:void(0)" class="header-home-a" @click="logout">退出登录</a>
      </div>
      <div class="header-home">
        <a href="javascript:void(0)" @click="manager('/login')" class="header-home-a">进入登录页</a>
      </div>
      <div class="header-home">
        <a href="javascript:void(0)" @click="manager('/')" class="header-home-a">回到首页</a>
      </div>
    </div>
    <div class="message-update">
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item name="1" >
          <template slot="title">
             用户名：{{ userCustomer.userName }}
             <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify1 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessageUserName" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="修改用户名：">
                <el-input v-model="updateMessage.userName" style="width: 3rem;"></el-input>
                <el-button type="primary" @click="update" style="height: 0.34rem; margin-left: 0.15rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2" >
          <template slot="title">
            密码：***
            <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify2 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessageUserName" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="新密码：">
                <el-input type="password" v-model="updateMessage.password" style="width: 2rem;" show-password></el-input>
              </el-form-item>
              <el-form-item label="新密码确认：">
                <el-input type="password" v-model="passwordNews" style="width: 2rem;" show-password></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="update" style="height: 0.34rem;width: 2rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3" >
          <template slot="title">
            昵称：{{ userCustomer.nickName }}
            <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify3 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessageNickName" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="修改昵称：">
                <el-input v-model="updateMessage.nickName" style="width: 3rem;"></el-input>
                <el-button type="primary" @click="update" style="height: 0.34rem; margin-left: 0.15rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="4" >
          <template slot="title">
            手机号：{{ userCustomer.phonenumber }}
            <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify4 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessagePhonenumber" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="修改手机号：">
                <el-input v-model="updateMessage.phonenumber" style="width: 3rem;"></el-input>
                <el-button type="primary" @click="update" style="height: 0.34rem; margin-left: 0.15rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="5" >
          <template slot="title">
            性别：{{userCustomer.sex ? '女' : '男'}}
            <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify5 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessageSex" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="修改性别：">
                <el-radio-group v-model="sex" @change="radioChange">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
                <el-button type="primary" @click="update" style="height: 0.34rem; margin-left: 0.15rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="6" >
          <template slot="title">
            邮箱：{{ userCustomer.email }}
            <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify6 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessageEmail" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="修改邮箱：">
                <el-input v-model="updateMessage.email" style="width: 3rem;"></el-input>
                <el-button type="primary" @click="update" style="height: 0.34rem; margin-left: 0.15rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="7" >
          <template slot="title">
            生日：{{ userCustomer.birthday }}
            <a href="javascript:void(0)" style="padding-right: 0.1rem;">{{ modify7 }}</a>
          </template>
          <div class="message-update-div">
            <el-form ref="updateMessageBirthday" :model="updateMessage" label-width="1rem" label-position="left">
              <el-form-item label="修改生日：">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择生日"
                  v-model="updateMessage.birthday"
                  style="width: 3rem;">
                </el-date-picker>
                <el-button type="primary" @click="update" style="height: 0.34rem; margin-left: 0.15rem;">修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
// 按需导入辅助函数
import { mapActions, mapState, mapMutations } from 'vuex'
// 按需导入 API 接口
import { updateUserCustomerAPI, killUserAPI } from '@/api/user'

export default {
  // name 是当前组件的名称（建议为每个组件都指定唯一的 name 名称）
  name: 'User',
  data () {
    return {
      activeNames: [],
      modify1: '修改',
      modify2: '修改',
      modify3: '修改',
      modify4: '修改',
      modify5: '修改',
      modify6: '修改',
      modify7: '修改',
      updateMessage: {
        userName: '',
        nickName: '',
        password: '',
        email: '',
        phonenumber: '',
        birthday: '',
        sex: 1
      },
      sex: 1,
      passwordNews: ''
    }
  },
  created () {
    this.initUserCustomer()
    this.updateMessageData()
  },
  activated () {
  },
  computed: {
    // 从 vuex 中把指定名称的 State 数据映射到组件中使用
    ...mapState(['tokenCustomer', 'userCustomer'])
  },
  watch: {
    userCustomer: function () {
      this.updateMessageData()
      this.updateMessage.password = ''
      this.passwordNews = ''
    }
  },
  methods: {
    // 从 vuex 中把指定名称的 Action 方法映射到组件中使用
    ...mapActions(['initUserCustomer']),
    ...mapMutations(['cleanState']),
    updateMessageData () {
      this.updateMessage.userName = this.userCustomer.userName
      this.updateMessage.nickName = this.userCustomer.nickName
      this.updateMessage.email = this.userCustomer.email
      this.updateMessage.phonenumber = this.userCustomer.phonenumber
      this.updateMessage.birthday = this.userCustomer.birthday
      this.updateMessage.sex = this.userCustomer.sex
      this.sex = this.userCustomer.sex
    },
    radioChange () {
      this.updateMessage.sex = this.sex
    },
    async update () {
      if (this.passwordNews === this.updateMessage.password) {
        const { data: res } = await updateUserCustomerAPI(this.updateMessage, this.tokenCustomer.token)
        if (res.code === 200) {
          this.$message({
            duration: 30000,
            message: '已修改用户内容',
            type: 'success'
          })
        }
        this.initUserCustomer()
        this.updateMessage.password = ''
        this.passwordNews = ''
      } else {
        this.$message({
          message: '新密码和新密码确认不一致',
          type: 'warning'
        })
      }
    },
    handleChange(val) {
      if (val !== '') {
        if (val === '1') {
          this.modify1 = '收起'
          this.modify2 = '修改'
          this.modify3 = '修改'
          this.modify4 = '修改'
          this.modify5 = '修改'
          this.modify6 = '修改'
          this.modify7 = '修改'
        } else if (val === '2') {
          this.modify1 = '修改'
          this.modify2 = '收起'
          this.modify3 = '修改'
          this.modify4 = '修改'
          this.modify5 = '修改'
          this.modify6 = '修改'
          this.modify7 = '修改'
        } else if (val === '3') {
          this.modify1 = '修改'
          this.modify2 = '修改'
          this.modify3 = '收起'
          this.modify4 = '修改'
          this.modify5 = '修改'
          this.modify6 = '修改'
          this.modify7 = '修改'
        } else if (val === '4') {
          this.modify1 = '修改'
          this.modify2 = '修改'
          this.modify3 = '修改'
          this.modify4 = '收起'
          this.modify5 = '修改'
          this.modify6 = '修改'
          this.modify7 = '修改'
        } else if (val === '5') {
          this.modify1 = '修改'
          this.modify2 = '修改'
          this.modify3 = '修改'
          this.modify4 = '修改'
          this.modify5 = '收起'
          this.modify6 = '修改'
          this.modify7 = '修改'
        } else if (val === '6') {
          this.modify1 = '修改'
          this.modify2 = '修改'
          this.modify3 = '修改'
          this.modify4 = '修改'
          this.modify5 = '修改'
          this.modify6 = '收起'
          this.modify7 = '修改'
        } else if (val === '7') {
          this.modify1 = '修改'
          this.modify2 = '修改'
          this.modify3 = '修改'
          this.modify4 = '修改'
          this.modify5 = '修改'
          this.modify6 = '修改'
          this.modify7 = '收起'
        }
      } else {
        this.modify1 = '修改'
        this.modify2 = '修改'
        this.modify3 = '修改'
        this.modify4 = '修改'
        this.modify5 = '修改'
        this.modify6 = '修改'
        this.modify7 = '修改'
      }
    },
    // 点击了退出登录
    async logout () {
      this.$confirm('您好，您确认退出登录吗？', '注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // TODO：实现退出的登录操作：
        // 1. 清空 vuex 中的数据
        // 2. 清空本地的数据
        this.cleanState()
        // 3. 跳转到登录页
        this.$router.push('/')
        this.$message({
          type: 'success',
          message: '退出登录成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出登录！'
        })
      })
    },
    killUser () {
      this.$confirm('您好，您确认注销该用户吗？', '注意', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await killUserAPI(this.tokenCustomer.token)
        // 判断是否登录成功了
        if (res.code === 200) {
          // 1. 清空 vuex 中的数据
          // 2. 清空本地的数据
          this.cleanState()
          // 3. 跳转到首页
          this.$router.push('/')
          this.$message({
            type: 'success',
            message: '此用户注销成功!'
          })
        } else {
          this.$message({
            message: '此用户注销失败',
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消注销！'
        })
      })
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    },
    manager (address) {
      this.$router.push({ path: address })
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none!important;
}
a:hover {
  color: red!important;
}
.all-page {
  background-color: #edf4fc;
  height: 100vh;
  width: 10rem;
}
.header {
  height: 0.5rem;
  margin: 0 0.1rem 0.1rem 0;
}
.menu-img-size {
  width: 1rem;
  height: 0.5rem;
}
.header-manager {
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  font-size: 0.25rem;
  color: gray;
  margin-left: 0.2rem;
}
.header-home {
  float: right;
  margin-right: 0.1rem !important;
  height: 0.5rem;
  font-size: 0.13rem;
  padding-right: 0.2rem;
}
.header-home-a {
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  vertical-align: middle;
  text-align: center;
}
.message-update {
  margin: 0.1rem;
}
.message-update-div {
  background-color: #f5fcf5;
  padding: 0 0.1rem 0 0.1rem;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
/deep/ .el-collapse-item__header {
  font-size: 0.13rem;
  padding-left: 0.1rem;
  justify-content: space-between;
}
/deep/ .el-collapse-item__arrow{
  display: none;
}
/deep/ .el-collapse-item__content {
    padding-bottom: 0;
}
/deep/ .el-form-item__label {
  padding: 0;
  font-size: 0.13rem;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
/deep/ .el-radio__inner {
  font-size: 0.13rem;
}
/deep/ .el-radio {
  font-size: 0.13rem;
}
/deep/ .el-radio__label {
  font-size: 0.13rem;
}
/deep/ .el-message p {
  font-size: 0.13rem;
}
</style>

<style>
.el-message-box__message p {
  font-size: 0.13rem;
}
.el-button--small {
  font-size: 0.13rem;
}
.el-message p {
  font-size: 0.13rem;
}
.el-message__icon {
  font-size: 0.13rem;
}
</style>
